import en from './en.json'
import it from './it.json'

export const operatorsTranslations = {
	en,
	it
} as const
